var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTennis = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  clipPath: "url(#tennis_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.531 8A7.531 7.531 0 1 1 .47 8a7.531 7.531 0 0 1 15.06 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.017 15.531h-.096C5.269 15.47 3.369 12.935 4 10.36 4.601 7.915 5.607 6.026 5.607 5a2.606 2.606 0 0 0-2.605-2.605"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.967 15.531h.097c2.652-.06 4.552-2.595 3.92-5.171-.601-2.445-1.607-4.334-1.607-5.359a2.606 2.606 0 0 1 2.606-2.605"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "tennis_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgTennis;